import { SET_AUTH, LOG_OUT } from "./mutation-types";

const kAuth = "auth";
const {
  userName,
  userId,
  shopId,
  token,
  referralCode,
  IsShopCheck,
  IsShopSubmit,
} = JSON.parse(localStorage.getItem(kAuth)) || {
  userName: null,
  userId: null,
  shopId: null,
  token: null,
  ReferralCode: null,
  IsShopCheck: 0,
  IsShopSubmit: 0,
};
// 获取urltoken
const getQueryVariable = (variable) => {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return "-1";
};

export default {
  state: {
    userName: userName,
    userId: userId,
    shopId: shopId,
    token: token,
    referralCode: referralCode,
    IsShopCheck: IsShopCheck,
    IsShopSubmit: IsShopSubmit,
  },
  getters: {
    isLogging(state) {
      if (getQueryVariable("token") !== "-1" && !state.token) {
        const auth = {
          userName: null,
          token: getQueryVariable("token"),
        };
        localStorage.setItem(kAuth, JSON.stringify(auth));
        return true;
        // } else if (state.userName && state.token) {
      } else if (state.token) {
        return true;
      } else {
        return false;
      }
    },
    tokenHeaders(state, getters) {
      if (!getters.isLogging) return {};
      return { Authorization: "Bearer " + state.token };
    },
  },
  mutations: {
    [SET_AUTH](state, data) {
      const {
        UserName,
        UserId,
        ShopId,
        Ticket,
        ReferralCode,
        IsShopCheck,
        IsShopSubmit,
      } = data;
      if (UserName) state.userName = UserName;
      if (UserId) state.userId = UserId;
      if (ShopId) state.shopId = ShopId;
      if (Ticket) state.token = Ticket;
      if (ReferralCode) state.referralCode = ReferralCode;
      state.IsShopCheck = IsShopCheck;
      state.IsShopSubmit = IsShopSubmit;
      const login = {
        userName: state.userName,
        userId: state.userId,
        shopId: state.shopId,
        token: state.token,
        referralCode: state.referralCode,
        IsShopCheck: state.IsShopCheck,
        IsShopSubmit: state.IsShopSubmit,
      };
      localStorage.setItem(kAuth, JSON.stringify(login));
    },
    [LOG_OUT](state) {
      state.userName = null;
      state.userId = null;
      state.shopId = null;
      state.token = null;
      state.referralCode = null;
      state.IsShopCheck = 0;
      state.IsShopSubmit = 0;
      const login = {
        userName: null,
        userId: null,
        shopId: null,
        token: null,
        referralCode: null,
        IsShopCheck: 0,
        IsShopSubmit: 0,
      };
      localStorage.setItem(kAuth, JSON.stringify(login));
    },
  },
};
